<div class="row">
  <div class="col">
    Business Type: {{business_types[business_type_id]}}
  </div>

  <div class="col">
    Product: {{products[product_id]}}
  </div>
</div>
<div class="form-group">
  <label>Commisssion</label>
  <input type="number" class="form-control" #new_commission [value]="commssion">
</div>
<div class="row">
  <div class="col">
    <button style="margin-left: 40%;" mat-raised-button color="primary" (click)="updateCommission(new_commission.value)">Update</button>
  </div>
  <div class="col">
    <button style="margin-left: 40%;" mat-raised-button color="primary" (click)="closeComponent(null)">Close</button>
  </div>
</div>
